import React, { useState,useEffect } from "react";
import StudentSidebar from "../../../common/Sidebar/StudentSideBar";
import "./StudentNotes.css";

const initialState = {
	notes:"",
};

function StudentNotes({ educator }) {
  const [form, setForm] = useState(initialState);
  const [list,setList] = useState([]);

  useEffect(()=>{
    const u=JSON.parse(localStorage.getItem('user'));
    fetch("https://edtechv.herokuapp.com/api/get_notes", {
				method: "post",
				headers: { "Content-type": "application/json" },
				body: JSON.stringify({
				  email: u.email,
				}),
			  })
				.then((response) => response.json())
				.then((user) => {
				  setList(user);
          console.log(user);
				});
  },[]);

  function handleUpload(e){
    const u=JSON.parse(localStorage.getItem('user'));
    e.preventDefault();
    fetch("https://edtechv.herokuapp.com/api/add_notes", {
				method: "post",
				headers: { "Content-type": "application/json" },
				body: JSON.stringify({
				  email: u.email,
          date: Date().toLocaleString(),
          text: form.notes,
				}),
			  })
				.then((response) => response.json())
				.then((user) => {
          console.log(user);
				  alert(user);
          console.log(list);
				});
  }
  const handleChange = (e) =>
		setForm({ ...form, [e.target.name]: e.target.value });
  return (
    <div className="educator-home">
      <StudentSidebar />
      <div className="home-main" style={{height:"100vh"}}>
        <h1>Student Notes</h1>
        <div class="form-group mt-2" style={{margin:"40px"}}>
            <label>Enter Notes</label>
            <textarea class="form-control" name="notes" onChange={handleChange}></textarea>
            <div>
          <button style={{marginTop:"20px"}}type="button" className="btn btn-warning" onClick={handleUpload}>Upload Notes</button>
        </div>
        </div>
        {list.length!==0&&list.map((ele,i)=>
      <div className="input-group mb-3" style={{marginTop:"50px"}}>
      <textarea type="text" value={ele.text} className="card-body" placeholder="Recipient's username" id="myInput" aria-label="Recipient's username" aria-describedby="basic-addon2" disabled/>
       {/* <label className="input-group-text" id="basic-addon2" >{ele.date.substring(0,ele.date.indexOf("GMT"))}</label> */}
   </div>
        )}
        
      </div>
    </div>
  );
}

export default StudentNotes;
